import { observable, makeObservable, action } from 'mobx';
import { State, setCompetencyId } from './Types';

class CompetenciesStore {
  @observable
  state: State;

  constructor(id: number) {
    makeObservable(this);
    this.state = setCompetencyId(id);
  }

  @action
  updateCompetencyId = (id: number) => {
    this.state = setCompetencyId(id);
  };
}

export default CompetenciesStore;
